import { removeComponentProps } from '@hts/shared/utils';
import { InputHTMLAttributes, forwardRef, memo, useCallback, useMemo } from 'react';
import styles from '../styles/IconInput.module.scss';

interface IconInputProps {
  name?: string;
  value: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  placeholder?: string;
  fullWidth?: boolean;
  containerProps?: InputHTMLAttributes<HTMLInputElement>;
  disabled?: boolean;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  onChangeValue: (value: string) => void;
}

export const IconInput = memo(
  forwardRef<HTMLInputElement, IconInputProps>(
    (
      {
        name,
        value,
        leftIcon,
        rightIcon,
        placeholder,
        containerProps,
        disabled,
        fullWidth = true,
        inputProps,
        onChangeValue,
      },
      ref
    ) => {
      const newMenuContainerProps = removeComponentProps(containerProps, ['className', 'style']);

      const containerStyles: React.CSSProperties = useMemo(
        () => ({
          ...containerProps?.style,
          width: fullWidth ? '100%' : containerProps?.style?.width || 'max-content',
        }),
        [containerProps?.style, fullWidth]
      );

      const onChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
          onChangeValue(e.target.value);
        },
        [onChangeValue]
      );

      return (
        <div
          className={[styles.container, containerProps?.className].join(' ')}
          style={containerStyles}
          {...newMenuContainerProps}
        >
          {leftIcon && <div className={styles.leftIconContainer}>{leftIcon}</div>}

          <input
            ref={ref}
            name={name}
            value={value}
            placeholder={placeholder || 'Search...'}
            onChange={onChange}
            disabled={disabled}
            {...inputProps}
          />

          {rightIcon && <div className={styles.rightIconContainer}>{rightIcon}</div>}
        </div>
      );
    }
  )
);
